module.exports = __webpack_public_path__ + "img/8.590bf2e0.png";